import { CustomImage as Image } from 'components/index';
import { CSSProperties } from 'react';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import styles from './BentoCard.module.css';

type BackgroundProps =
  | { bgColor: string; bgGradient?: never; bgImage?: never; boxShadow?: never }
  | { bgGradient: string; bgColor?: never; bgImage?: never; boxShadow?: never }
  | { bgImage: string; bgColor?: never; bgGradient?: never; boxShadow?: never }
  | {
      boxShadow: string;
      bgImage?: never;
      bgColor: string;
      bgGradient?: never;
    };

// Values arrive as raw CSS-declaration fragments (some with a trailing ';'),
// which is invalid inside an inline style value — strip it before assigning.
const cleanCssValue = (value: string) => value.replace(/;\s*$/, '').trim();

export const BentoCard = (
  props: {
    className?: string;
    parentType: 'grid' | 'flex';
    caption?: string;
    title?: string | React.ReactNode;
    textAlign?: 'left' | 'center' | 'right';
    colReverse?: boolean;
    textColor?: string;
    gridColumn?: string;
    gridRow?: string;
    image?: string;
    alt?: string;
    centerImage?: string;
  } & BackgroundProps,
) => {
  const cardStyle: CSSProperties = {
    ['--grid-column' as any]: props.gridColumn || 'auto',
    ['--grid-row' as any]: props.gridRow || 'auto',
  };
  if (props.bgColor) cardStyle.backgroundColor = cleanCssValue(props.bgColor);
  if (props.bgGradient) cardStyle.background = cleanCssValue(props.bgGradient);
  if (props.bgImage) {
    cardStyle.backgroundImage = `url(${getCompressedAssetUrl(props.bgImage)})`;
    cardStyle.backgroundSize = 'cover';
    cardStyle.backgroundPosition = 'center';
    cardStyle.backgroundRepeat = 'no-repeat';
  }
  if (props.boxShadow) cardStyle.boxShadow = cleanCssValue(props.boxShadow);

  const textStyle = props.textColor
    ? ({ ['--text-color' as any]: props.textColor } as CSSProperties)
    : undefined;

  return (
    <div
      className={
        props.className ? `${styles.card} ${props.className}` : styles.card
      }
      data-parent-type={props.parentType}
      data-col-reverse={props.colReverse ? 'true' : undefined}
      style={cardStyle}
    >
      {props.title || props.caption ? (
        <div
          className={styles.textContainer}
          data-text-align={props.textAlign}
          style={textStyle}
        >
          {props.caption ? (
            <p className={styles.caption}>{props.caption}</p>
          ) : null}
          {props.title ? <h3 className={styles.title}>{props.title}</h3> : null}
        </div>
      ) : null}
      {props.image ? (
        <div className={styles.imageContainer}>
          <Image
            src={props.image}
            alt={props.alt || 'Ultrahuman Blood Vision - features image'}
            width={600}
            height={400}
          />
        </div>
      ) : null}

      {props.centerImage ? (
        <div className={styles.imageContainerCentered}>
          <Image
            src={props.centerImage}
            alt={props.alt || 'Ultrahuman Blood Vision - features image'}
            width={600}
            height={400}
          />
        </div>
      ) : null}
    </div>
  );
};
